import { Period } from './period';

export class DuePeriod {
    id: number;
    period: Period;
    frequency: number;
}
